/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import {list} from '../../service/inventory/house';
import { Store, Actions } from './store';

class Warehouse extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      filterBoxVisible: false,
      rows: [],
      total: 0,
      searchObj: {
        code: '',
        name: '',
        address: '',
        active: null,
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'warehouse' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange({useHouseStore: true});
      Actions.paramChange('houseParams', {...this.state.searchObj});
    }else{
      Actions.useStoreChange({useHouseStore: false});
    }
  }
  componentWillMount () {
    const data = this.store.state;
    if (data.useHouseStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.houseParams,
        }
      });
    }
  }

  componentDidMount(){
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }
  getData(){
    const self = this;
    const {searchObj} = this.state;
    list(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total,rows: res.data});
      }
    });
  }
  goView (url) {
    hashHistory.push(url);
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    const self = this;
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        code: '',
        name: '',
        address: '',
        active: '',
        //s: 10,
        p: 1,
      }
    }, ()=>{
      self.getData();
    })
  };

  advanceSubmit (form) {
    const self = this;
    this.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        p: 1
      }
    }, function(){
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'lastOperationTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          lastOperationTimeStart: value.from,
          lastOperationTimeEnd: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    })
  }

  render () {
    const { filterBoxVisible, rows, total, searchObj } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'code',
            label: '仓库编码',
            text: '输入仓库编码',
            defaultValue: searchObj.code,
            type: 'default'
          },
          {
            name: 'name',
            label: '仓库名称',
            text: '输入仓库名称',
            defaultValue: searchObj.name,
            type: 'default'
          },
          /*{
            name: 'kw',
            label: '所属地区',
            text: '所属地区',
            defaultValue: searchObj.kw,
            type: 'default'
          },*/
          {
            name: 'address',
            label: '详细地址',
            text: '输入详细地址',
            defaultValue: searchObj.address,
            type: 'default'
          },
          {
            name: 'active',
            label: '状态',
            text: '选择状态',
            dataType: 'number',
            defaultValue: searchObj.active !== null ? searchObj.active+'' : 'null',
            options: [
              { value: null, text: '全部' },
              { value: '1', text: '有效' },
              { value: '0', text: '失效' },
            ],
            multiple: false,//支持多选
            type: 'select'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '仓库编码',
          dataIndex: 'code',
          render: (text, record, index) => {
            return <a href={`#/warehouse/${record.id}`}>{text}</a>
          }
        },
        {
          title: '名称',
          dataIndex: 'name',
          render: (text, record, index) => {
            return <a href={`#/warehouse/${record.id}`}>{text}</a>
          }
        }, {
          title: '联系人',
          dataIndex: 'contacts'
        }, {
          title: '联系电话',
          dataIndex: 'contactsMobile'
        }, {
          title: '辐射区域',
          dataIndex: 'storageAreaList',
          render: (text, record, index) => {
            return <div className="bu_s_h">{text.map( x => x.areaName||'--').join()}</div>;
          }
        }, {
          title: '详细地址',
          dataIndex: 'address',
          render: text => <div className="bu_s_h">{text}</div>
        }, {
          title: '状态',
          dataIndex: 'active',
          render: (text, record, index) => text === 1 ? <span style={{color: 'green'}}>有效</span> : <span style={{color: '#d61518'}}>失效</span>
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['仓库列表']} defaultKey={0}>
        <Button icon="plus" onClick={this.goView.bind(this, `/warehouse/add/0`)}>新增</Button>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
export default withRouter(Warehouse);



// WEBPACK FOOTER //
// ./src/routes/inventory/warehouse.js